module.exports = __webpack_public_path__ + "img/new_whale_image.90d5f92c.jpg";